import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ApiResourceLocation, ResponseResult } from '@softline/core';
import { Checkliste } from '../types/checkliste';
import { SOFTLINE_API_CHECKLISTE_ENTITIES } from '../checkliste.api';

@Injectable({ providedIn: 'root' })
export class TaskRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  async create(betreff: string): Promise<Checkliste> {
    const location: ApiResourceLocation = { path: SOFTLINE_API_CHECKLISTE_ENTITIES };
    const body = { betreff };

    const response = await this.#dataAccess.create<
      { betreff: string },
      ResponseResult<Checkliste>
    >(location, body);

    return response.result;
  }
}
